import { resolveBrandConfig } from "@/branding/brandConfig";
import { stripQueryAndHash } from "@/lib/authRedirect";

export const EDUCATION_HOME_PATH = "/education";

export function organizationHomePath(organizationCode: string | null | undefined) {
  return resolveBrandConfig(organizationCode).homePath;
}

export function isWorkspaceHomePath(path: string) {
  const routePath = stripQueryAndHash(path);
  return routePath === "/" || routePath === EDUCATION_HOME_PATH;
}

export function resolveOrganizationDestination(
  requestedPath: string,
  organizationCode: string | null | undefined,
) {
  if (!isWorkspaceHomePath(requestedPath)) {
    return requestedPath;
  }
  const suffixMatch = requestedPath.match(/[?#].*$/);
  return `${organizationHomePath(organizationCode)}${suffixMatch?.[0] || ""}`;
}
